import {PageHeader} from '@primer/react'
import {PeriodMenu} from './PeriodMenu'
import {SkeletonText} from '@primer/react/experimental'

interface PulseHeaderProps {
  rangeLabel: string
  loaded?: boolean
}

export function PulseHeader({rangeLabel = ' ', loaded = false}: PulseHeaderProps) {
  const displayTitle = rangeLabel
  return (
    <PageHeader hasBorder>
      <PageHeader.TitleArea>
        {loaded ? <PageHeader.Title>{displayTitle}</PageHeader.Title> : <SkeletonText size="titleMedium" />}
      </PageHeader.TitleArea>
      <PageHeader.Actions>
        <PeriodMenu />
      </PageHeader.Actions>
    </PageHeader>
  )
}
